export { default } from "./tag-card"
